import React, { useEffect, useState } from "react";
import SiteContent from "../components/site-items/SiteContent/SiteContent";
import Navbar from "../parts/Navbar/Navbar";
import Footer from "../parts/Footer/Footer";
import PageWrapper from "../components/page-items/PageWrapper/PageWrapper";
import PageHeader from "../components/page-items/PageHeader/PageHeader";
import PageContent from "../components/page-items/PageContent/PageContent";
import { scrollToTop } from "../helpers/helpersFunctions";
import Menu from "../components/buttons/Menu/Menu";
import SectionHeader from "../components/section-items/SectionHeader/SectionHeader";
import SectionSubheader from "../components/section-items/SectionSubheader/SectionSubheader";
import SectionBody from "../components/section-items/SectionBody/SectionBody";
import PlayerCard from "../sections/Team/PlayerCard/PlayerCard";
import PlayerCardContainer from "../sections/Team/PlayerCardContainer";
import { fetchData } from "../helpers/fetchData";
import LoadingSpinner from "../components/spinners/LoadingSpinner";
import { ABOUT_US } from "../utils/info";

const Team = () => {
    const [players, setPlayers] = useState([]);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        scrollToTop();
        fetchData("players")
            .then((res) => setPlayers(res))
            .then(() => setIsFetching(false))
            .catch((e) => console.error(e));
    }, []);

    const renderPlayers = () => {
        return players.map((e, index) => (
            <PlayerCard
                key={e.name + e.surname + index}
                name={e.name}
                surname={e.surname}
                dateOfBirth={e.date_of_birth}
                numberOfGoals={e.number_of_goals}
                numberOfMatches={e.number_of_matches}
                position={e.position}
                nationality={e.country}
            />
        ));
    };

    return (
        <SiteContent>
            <Navbar />
            <PageWrapper
                style={{
                    background:
                        "linear-gradient(to bottom, #F7FAF2, 90%, #fdeaa7)",
                }}
            >
                <PageContent paddingBottom={"0px"}>
                    <PageHeader header={"Team"} />
                    <SectionBody>
                        <SectionHeader>{"Poznaj naszą drużynę"}</SectionHeader>
                        <SectionSubheader>{ABOUT_US}</SectionSubheader>
                        <PlayerCardContainer>
                            {isFetching ? <LoadingSpinner /> : renderPlayers()}
                        </PlayerCardContainer>
                    </SectionBody>
                </PageContent>
            </PageWrapper>
            <Menu />
            <Footer />
        </SiteContent>
    );
};

export default Team;
